/**
 * Copied from ADS popup component with some tweeks for our use
 */
import React, { Fragment, useLayoutEffect, useRef } from 'react';
// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var RepositionOnUpdate = function RepositionOnUpdate(_ref) {
  var children = _ref.children,
    update = _ref.update,
    settings = _ref.settings;
  // Ref used here to skip update on first render (when refs haven't been set)
  var isFirstRenderRef = useRef(true);
  useLayoutEffect(function () {
    if (isFirstRenderRef.current) {
      isFirstRenderRef.current = false;
      return;
    }
    // callback function from popper that repositions pop-up on content Update
    update();
  }, [update, settings]);

  // wrapping in fragment to make TS happy (known issue with FC returning children)
  return /*#__PURE__*/React.createElement(Fragment, null, children);
};